import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';


import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const PopularDishes = () => {
  const [selectedDish, setSelectedDish] = useState(null);

  const dishes = [
    {
      name: "Swaad of Gujarat",
      description: "Traditional Gujarati meal with authentic flavors.",
      img: "assets/img/menu/dish1.png",
      items: [
        "Khaman-Dhokla",
        "Shaak",
        "Puri/Rotli/Bhakhri",
        "Gujarati Dal",
        "Rice",
        "Salad",
        "Khichadi-Kadhi",
        "Pickle",
        "Papad",
        "Gulab-jamun",
      ],
    },
    {
      name: "Kathiyawadi Classic Spread",
      description: "Spicy and flavorful Kathiyawadi specialties.",
      img: "assets/img/menu/dish4.png",
      items: [
        "Lasaniya Bataka",
        "Ringan No Olo",
        "Bajra Rotla",
        "Sev-tameta",
        "Marchaa",
        "Gol",
        "Chaas",
        "Khichdi-Kadhi",
        "Papad",
      ],
    },
    {
      name: "Flavours of Rajasthan",
      description: "Rich royal taste of Rajasthan on one plate.",
      img: "assets/img/menu/dish3.png",
      items: [
        "Dal Baati",
        "Churma",
        "Gatte Ki Sabji",
        "Ker Sangri",
        "Bajra Roti",
        "Jeera Rice",
        "Malpua",
        "Salad",
        "Papad",
      ],
    },
    {
      name: "Punjab Di Shaan",
      description: "Hearty Punjabi feast with rich flavors.",
      img: "assets/img/menu/dish2.png",
      items: [
        "Paneer Tikka",
        "Panner Angara",
        "Dal Makhani",
        "Butter Naan",
        "Jeera Rice",
        "Lassi",
        "Gulab Jamun",
        "Salad"
      ],
    },
    {
      name: "Undhiyu & Puri Signature Spread",
      description: "Classic winter special with puri and undhiyu.",
      img: "assets/img/menu/undhiyu_puri.png",
      items: [
        "Undhiyu",
        "Puri",
        "Shrikhand",
        "Jalebi-fafda",
        "Papad",
        "Salad",
      ],
    },
  ];

  return (
    <>
      <section className="popular-dishes-section fix section-padding bg-color2">
        <div className="popular-dishes-wrapper style1">
          <div className="shape1 d-none d-xxl-block">
            <img
              src="assets/img/shape/popularDishesShape1_1.png"
              alt="shape"
            />
          </div>

          <div className="shape2 float-bob-y d-none d-xxl-block">
            <img
              src="assets/img/shape/popularDishesShape1_2.png"
              alt="shape"
            />
          </div>

          <div className="container">
            <div className="title-area">
              <h2 className="title">
                Signature dish from our premium catering services
              </h2>
            </div>

            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={30}
              slidesPerView={3}
              loop={true}
              autoplay={{ delay: 2500 }}
              breakpoints={{
                320: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
                1200: { slidesPerView: 3 },
              }}
              className="mySwiper"
            >
              {dishes.map((dish, index) => (
                <SwiperSlide key={index}>
                  <div className="dishes-card style1">
                    <div className="dishes-thumb">
                      <img src={dish.img} alt={dish.name} />
                    </div>

                    <h3>{dish.name}</h3>

                    <h6>{dish.description}</h6>

                    <div className="mt-3">
                      <button
                        className="theme-btn"
                        data-bs-toggle="modal"
                        data-bs-target="#dishModal"
                        onClick={() => setSelectedDish(dish)}
                      >
                        View Menu
                      </button>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            {/* <div className="btn-wrapper mt-4">
              <a className="theme-btn" href="/menu">
                VIEW ALL ITEM{" "}
                <i className="fa-sharp fa-regular fa-arrow-right"></i>
              </a>
            </div> */}
          </div>
        </div>
      </section>

      {/* Modal */}
      <div
        className="modal fade"
        id="dishModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" style={{
          maxWidth: "550px"
        }}>
          <div
            className="modal-content"
            style={{
              background: "#FCF8EE",
              borderRadius: "12px",
              border: "none",
            }}
          >

            {/* Absolute positioned Close Button */}
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              style={{
                position: "absolute",
                right: "15px",
                top: "10px",
                fontSize: "0.8rem"
              }}
            ></button>
            <div className="w-100 text-center">
              <h4
                style={{
                  fontFamily: "Georgia, serif",
                  fontWeight: "600",
                  color: "#6B4F1D",
                  margin: "18px 0 5px 0",
                }}
              >
                {selectedDish?.name}
              </h4>

              <small style={{ color: "#9A7B4F" }}>
                Premium Catering Selection
              </small>

            </div>

            <div
              className="modal-body"
              style={{
                background: "#FCFAF3",
                padding: "20px",
              }}
            >
              {selectedDish && (
                <>
                  <div className="text-center mb-4">
                    <img
                      src={selectedDish.img}
                      alt={selectedDish.name}
                      style={{
                        width: "120px",
                        height: "120px",
                        borderRadius: "50%",
                        objectFit: "cover",
                        border: "4px solid #d4a017",
                      }}
                    />
                  </div>

                  <div className="mt-4">
                    {selectedDish.items.map((item, index) => (
                      <div
                        key={index}
                        style={{
                          padding: "8px 0",
                          fontSize: "16px",
                          borderBottom: "1px dashed #e7d9b6",
                          color: "#555",
                        }}
                      >
                        • {item}
                      </div>
                    ))}
                  </div>

                  <div className="text-center mt-4">
                    <a
                      href="/build-menu"
                      className="theme-btn"
                      style={{
                        borderRadius: "50px",
                        padding: "10px 25px",
                      }}
                    >
                      View Full Menu
                    </a>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default PopularDishes;